import { Grid, Paper, TextField, Typography } from "@material-ui/core";
type SlagReportControlProps = {
	settings: {
		[key: string]: any;
	};
};

export const SlagReportControl = ({ settings }: SlagReportControlProps) => {
	return (
		<Grid item container xs={6} alignItems="center" justifyContent="center">
			<Paper
				style={{
					display: "flex",
					justifyContent: "center",
					padding: "9px",
				}}
			>
				<Grid container spacing={1}>
					<Grid item xs={3}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="B3ratio"
							variant="outlined"
							value={`${settings.SLAG_REPORT_B3RATIO_MIN} – ${settings.SLAG_REPORT_B3RATIO_MAX}`}
							style={{ minWidth: "50px" }}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="%MgO"
							variant="outlined"
							value={`${settings.SLAG_REPORT_MGO_MIN} – ${settings.SLAG_REPORT_MGO_MAX}`}
							style={{ minWidth: "50px" }}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="%FeO"
							variant="outlined"
							value={`≤ ${settings.SLAG_REPORT_FEO_MAX}`}
							style={{ minWidth: "50px" }}
						/>
					</Grid>
					<Grid item xs={3}>
						<TextField
							fullWidth
							size="small"
							disabled
							label="%Total"
							variant="outlined"
							value={`≥ ${settings.SLAG_REPORT_TOTAL_MIN}`}
							style={{ minWidth: "50px" }}
						/>
					</Grid>
				</Grid>
			</Paper>
		</Grid>
	);
};
